import React from "react";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "../../config";
import { Formik, Form, Field, ErrorMessage } from "formik";
import SweetAlert from "react-bootstrap-sweetalert";
import { useAppContext } from "../../Lib/ContextLib";
import Select from "react-select";

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "12px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.1)" : "none",
    height: "48px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? "#ffc107" 
      : state.isFocused 
      ? "rgba(255, 193, 7, 0.1)" 
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
};

export default function Test({ rowValue, setTestPage, testPage }) {
  

  const { setShowPage } = useAppContext();
  const { socket } = useAppContext();
  const [buttonLoader3, setButtonLoader3] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const LoginSchema3 = Yup.object().shape({
    Amount: Yup.number().required("required"),
    note: Yup.string().required("required"),
    TransactionType: Yup.number().required("required"),
    walletType: Yup.number().required("required"),
  });

  const successEditStatus = (msg) => {
    console.log("donw");
    setTestPage(!testPage);
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={msg}
        onConfirm={() => {
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };
  const warningStatus = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block" }}
        title={msg}
        onConfirm={() => {
          setAlert(null);
        }}
        confirmBtnBsStyle="warning"
      ></SweetAlert>
    );
  };
  return (
    <div>
      {alert}
      <Formik
        initialValues={{
          Amount: "",
          note: "test",
          TransactionType: "",
          walletType: "",
        }}
        validationSchema={LoginSchema3}
        onSubmit={(values) => {
          setButtonLoader3(true);
          const testData = {
            amount: parseInt(values.Amount),
            transactionType: parseInt(values.TransactionType),
            walletType: parseInt(values.walletType),
          };
          console.log("testData:::::::", testData);

          axios(`${API_URL}/api/admin/player/test-money-add/${rowValue._id}`, {
            method: "POST",
            credentials: "include",
            data: testData,
          })
            .then((result) => {
              console.log("handleSubmit result :::", result.data);
              if (result.data.status) {
                const data = {
                  playerId: testData.playerId,
                  message: "Transaction",
                };
                console.log("data...", data);
                socket.emit("admin-player-balance-update", {
                  playerId: result.data.data.playerId,
                });
                setButtonLoader3(false);
                successEditStatus(result.data.message);
              } else {
                setButtonLoader3(false);
                warningStatus(result.data.message);
              }
            })
            .catch((err) => {
              console.log("handleSubmit err :::", err);
            });
        }}
      >
        {({ touched, errors, isSubmitting, values, setFieldValue }) => (
          <div className="premium-form-container">
            <Form>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.9rem', marginBottom: '8px', display: 'block' }}>
                      Amount <span className="text-danger">*</span>
                    </label>
                    <Field
                      type="number"
                      name="Amount"
                      placeholder="Enter Amount"
                      onChange={(e) => {
                        const re = /^[0-9]*\.?[0-9]*$/;
                        if (e.target.value === "" || re.test(e.target.value)) {
                          setFieldValue("Amount", e.target.value);
                        }
                      }}
                      className={`form-control premium-input ${touched.Amount && errors.Amount ? "is-invalid" : ""}`}
                    />
                    <ErrorMessage component="div" name="Amount" className="invalid-feedback" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.9rem', marginBottom: '8px', display: 'block' }}>
                      Note <span className="text-danger">*</span>
                    </label>
                    <Field
                      type="text"
                      name="note"
                      disabled
                      className="form-control premium-input disabled-bg"
                    />
                    <ErrorMessage component="div" name="note" className="invalid-feedback" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.9rem', marginBottom: '8px', display: 'block' }}>
                      Transaction Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      styles={filterSelectStyles}
                      options={[
                        { value: 1, label: "Credit" },
                        { value: 0, label: "Debit" },
                      ]}
                      placeholder="Select Transaction Type"
                      value={[
                        { value: 1, label: "Credit" },
                        { value: 0, label: "Debit" },
                      ].find(opt => opt.value === values.TransactionType)}
                      onChange={(option) => setFieldValue("TransactionType", option.value)}
                    />
                    <ErrorMessage component="div" name="TransactionType" className="invalid-feedback" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.9rem', marginBottom: '8px', display: 'block' }}>
                      Add Wallet Type <span className="text-danger">*</span>
                    </label>
                    <Select
                      styles={filterSelectStyles}
                      options={[
                        { value: 0, label: "Deposite Balance" },
                        { value: 1, label: "Withdraw Balance" },
                        { value: 2, label: "Bonus Balance" },
                      ]}
                      placeholder="Select Add Balance Type"
                      value={[
                        { value: 0, label: "Deposite Balance" },
                        { value: 1, label: "Withdraw Balance" },
                        { value: 2, label: "Bonus Balance" },
                      ].find(opt => opt.value === values.walletType)}
                      onChange={(option) => setFieldValue("walletType", option.value)}
                    />
                    <ErrorMessage component="div" name="walletType" className="invalid-feedback" />
                  </div>
                </div>
              </div>

              <div className="d-flex mt-4 pt-4 border-top">
                <button
                  type="submit"
                  className="btn premium-submit-btn mr-2"
                  disabled={buttonLoader3}
                  style={{ width: "130px", height: "45px" }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <b>Submit</b>
                    {buttonLoader3 && (
                      <div className="spinner-border spinner-border-sm ml-2" role="status"></div>
                    )}
                  </div>
                </button>
                <button
                  type="button"
                  onClick={() => setShowPage(false)}
                  className="btn btn-light"
                  style={{ 
                    width: "130px", 
                    height: "45px", 
                    borderRadius: '12px', 
                    fontWeight: 600, 
                    color: '#64748b',
                    backgroundColor: '#f1f5f9',
                    border: 'none'
                  }}
                >
                  Cancel
                </button>
              </div>
            </Form>

            <style jsx>{`
              .disabled-bg {
                background-color: #f8fafc !important;
                border-color: #f1f5f9 !important;
                color: #64748b !important;
                cursor: not-allowed !important;
              }
            `}</style>
          </div>
        )}
      </Formik>
    </div>
  );
}
